import { schema } from "normalizr";

const subscriptionInvoice = new schema.Entity(`subscription_invoices`);
const arrayOfSubscriptionInvoices = [subscriptionInvoice];

export { subscriptionInvoice, arrayOfSubscriptionInvoices };
